import { SiteHeader } from '../components/SiteHeader';
import { useDocumentMeta } from '../lib/useDocumentMeta';

export function Home() {
  useDocumentMeta({ title: 'Home | Tyler Wrenn' });

  return (
    <div className="home-page">
      <main className="home-page__main container">
        <SiteHeader plain />
        <p className="text-center lead mt-3">
          A new site layout is under construction right now. Check back soon!
        </p>
      </main>
      <footer className="home-page__footer text-center">
        <p className="small">Designed by Tyler Wrenn</p>
      </footer>
    </div>
  );
}
